import type { DeviceCreate } from "@/types";

export interface DeviceCreateDraft {
  hardwareId: string;
  googleAccount: string;
  /** Hardware specs come from the preset unless the manual section is open. */
  manualMode: boolean;
  presetId: string | null;
  brand: string;
  model: string;
  androidVersion: string;
  displayResolution: string;
  displayInches: string;
}

export type DeviceCreateDraftError =
  | "hardware_id_required"
  | "google_account_required"
  | "preset_required"
  | "inches_invalid";

export type DeviceCreateRequestResult =
  | { ok: true; request: DeviceCreate }
  | { ok: false; error: DeviceCreateDraftError };

export function buildDeviceCreateRequest(
  draft: DeviceCreateDraft,
): DeviceCreateRequestResult {
  const serialNumber = draft.hardwareId.trim();
  if (!serialNumber) return { ok: false, error: "hardware_id_required" };
  const googleAccount = draft.googleAccount.trim();
  if (!googleAccount) return { ok: false, error: "google_account_required" };

  if (!draft.manualMode) {
    if (!draft.presetId) return { ok: false, error: "preset_required" };
    return {
      ok: true,
      request: {
        serial_number: serialNumber,
        google_account: googleAccount,
        device_preset_id: draft.presetId,
      },
    };
  }

  const displayInches = draft.displayInches.trim()
    ? Number.parseFloat(draft.displayInches)
    : undefined;
  if (displayInches !== undefined && Number.isNaN(displayInches)) {
    return { ok: false, error: "inches_invalid" };
  }
  return {
    ok: true,
    request: {
      serial_number: serialNumber,
      google_account: googleAccount,
      brand: draft.brand.trim() || undefined,
      model: draft.model.trim() || undefined,
      android_version: draft.androidVersion.trim() || undefined,
      display_resolution: draft.displayResolution.trim() || undefined,
      display_inches: displayInches,
    },
  };
}
